import React, { forwardRef } from 'react';
import { EzIconButtonMui } from './Implementations';
var EzIconButton = forwardRef(function (_ref, ref) {
  var _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'filled' : _ref$variant;
  return React.createElement(EzIconButtonMui, {
    ref: ref,
    ariaHidden: ariaHidden,
    ariaLabel: ariaLabel,
    color: color,
    disabled: disabled,
    onClick: onClick,
    onKeyDown: onKeyDown,
    size: size,
    type: type,
    variant: variant
  }, children);
});
EzIconButton.displayName = 'EzIconButton';
export default EzIconButton;